module.exports = __webpack_public_path__ + "static/media/order_packing_supplies.971b48dd.jpg";